import React from 'react';
import { useAuthModals } from '../contexts/AuthModalsContext';
import { AuthFlowModal } from './AuthFlowModal';
import { AuthSelectionModal } from './AuthSelectionModal';

export function AuthModals(): JSX.Element {
  const {
    showLoginModal,
    showRegisterModal,
    showAuthSelectionModal,
    authFlowMode,
    closeLoginModal,
    closeRegisterModal,
    closeAuthSelectionModal,
    openAuthFlowLogin,
    openAuthFlowSignup,
  } = useAuthModals();

  const handleSelectLogin = () => {
    closeAuthSelectionModal();
    setTimeout(openAuthFlowLogin, 50);
  };

  const handleSelectSignup = () => {
    closeAuthSelectionModal();
    setTimeout(openAuthFlowSignup, 50);
  };

  const handleCloseAuthFlow = () => {
    closeLoginModal();
    closeRegisterModal();
  };

  return (
    <>
      <AuthSelectionModal
        visible={showAuthSelectionModal}
        onClose={closeAuthSelectionModal}
        onSelectLogin={handleSelectLogin}
        onSelectSignup={handleSelectSignup}
      />

      <AuthFlowModal
        visible={showLoginModal || showRegisterModal}
        initialMode={authFlowMode}
        onClose={handleCloseAuthFlow}
        onLoginSuccess={() => {
          handleCloseAuthFlow();
        }}
      />
    </>
  );
}
